<div class="navigation-menu" *ngIf="showTemplate">
    <span class="hm-icon-close top-x" (click)="hide()"></span>
    <div class="navigation-selection">
        <a (click)="navigate('/annual-summary-dashboard')">
            <i class="fas fa-chevron-right"></i>
            <span>Annual summary</span>
        </a>
        <a (click)="navigate('/vfm-dashboard')">
            <i class="fas fa-chevron-right"></i>
            <span>VFM quadrant</span>
        </a>
        <a (click)="navigate('/bespoke-dashboard')">
            <i class="fas fa-chevron-right"></i>
            <span>Bespoke dashboard</span>
        </a>
    </div>
</div>
